import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@cwos/ui-shared';
import styles from './lists.module.css';
/**
 * `narrowedBy`'s third value: whether anything narrows this list is NOT KNOWN —
 * the read that would state it is in flight, failed, or was refused.
 *
 * Spelled `{ kind: 'unknown' }` on purpose. It is the same word and the same
 * discriminant `figureState.Population` and `DeliveryPopulation` already use for
 * this exact case, so this is the product's existing vocabulary reaching one
 * more surface rather than a new one invented for it.
 */
export const NARROWING_UNKNOWN = { kind: 'unknown' };
export function FilterSummary({ scope }) {
    const narrowings = scope.narrowings ?? [];
    /**
     * The frame the caller could not state. Checked BEFORE either sentence, so
     * neither can be reached by a screen that does not yet know which is true.
     */
    const frameUnknown = typeof scope.narrowedBy === 'object';
    const narrowedTo = typeof scope.narrowedBy === 'string' ? scope.narrowedBy : null;
    return (_jsxs("p", { className: styles.filterSummary, children: ["Showing ", _jsx("strong", { children: scope.what }), " from ", _jsx("strong", { children: scope.scope }), ", ", scope.period, ".", ' ', narrowings.length === 0 ? null : (_jsxs("span", { children: [narrowings.map((n, i) => (_jsxs("span", { children: [i === 0 ? 'Filtered by ' : ', ', _jsx("strong", { children: n.label })] }, `${n.label}-${i}`))), ".", ' '] })), frameUnknown ? null : narrowedTo !== null ? (_jsx("span", { className: styles.filterScoped, children: t('filters.scoped', { who: narrowedTo }) })) : narrowings.length === 0 ? (_jsx("span", { className: styles.filterNone, children: t('filters.none') })) : null] }));
}
//# sourceMappingURL=FilterSummary.js.map